import { Naja } from 'naja';
import { Extension } from 'naja/dist/Naja';

import Zoom from './Zoom';
import { ACTIVE_THUMB, CAROUSEL_CLASSNAME, HAS_CAROUSEL } from './constants';

class ResponsiveCarousel implements Extension {
  public readonly initialize = (naja: Naja): void => {
    naja.addEventListener('init', this.load);
    naja.addEventListener('complete', this.load);
  };

  public readonly load = (): void => {
    const carousels = document.getElementsByClassName(
      CAROUSEL_CLASSNAME,
    ) as HTMLCollectionOf<HTMLElement>;
    for (const e of carousels) {
      if (e.getAttribute(HAS_CAROUSEL) === null) {
        this.initCarousel(e);
      }
    }
  };

  private readonly initCarousel = (carousel: HTMLElement): void => {
    carousel.setAttribute(HAS_CAROUSEL, 'true');
    $(carousel).on('slide.bs.carousel', this.handleCarouselSlide(carousel));
    const zoom = new Zoom(carousel);
    zoom.init();
  };

  private readonly handleCarouselSlide =
    (carousel: HTMLElement) =>
    ({ to }: { to: number }): void => {
      const thumbs = document.getElementById(`${carousel.id}__thumbs`);
      if (!thumbs) return;
      for (let i = 0; i < thumbs.children.length; i++) {
        const thumb = thumbs.children[i];
        if (i === to) {
          thumb.classList.add(ACTIVE_THUMB);
        } else {
          thumb.classList.remove(ACTIVE_THUMB);
        }
      }
    };
}

export default ResponsiveCarousel;
